module.exports = __webpack_public_path__ + "media/images/4-highlighted-245411669e9af8635430fb8dbd34c118.png";